import { observable } from "micro-observables";

export const duplicateSessionHaloVisible = observable(false);

export const showDuplicateSessionHalo = (): void => {
    setTimeout(() => {
        duplicateSessionHaloVisible.set(true);
    }, 0);
};

export const hideDuplicateSessionHalo = (): void => {
    duplicateSessionHaloVisible.set(false);
};
